import { useState, useRef, useLayoutEffect, useCallback } from "react"
import PropTypes from "prop-types"
import { IconButton, CircularProgress } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { downloadXlsx } from "helpers/csv"
import { useReduceDownloadDataFromSubscribers } from "hooks/register-downloads"
import Tooltip from "components/material/tooltip"
import { useAnalytics } from "connected-components/analytics"
import { DASHBOARD_EVENTS } from "../../analytics"
import { getDownloadDataFileName, DOWNLOAD_SHEET_ORDER } from "../../helpers/download"

export default function DashboardDownload({ enterDelay = 300, instrumentMetadata, isIntraday }) {
  const buttonRef = useRef()
  const [loading, setLoading] = useState(false)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const analytics = useAnalytics()

  useLayoutEffect(() => {
    if (buttonRef.current) {
      setDimensions({
        width: buttonRef.current.offsetWidth,
        height: buttonRef.current.offsetHeight,
      })
    }
  }, [])

  const fileName = getDownloadDataFileName(instrumentMetadata, isIntraday)
  const type = "csv"
  const title = "Download as XLSX"

  const reduceDownloadData = useReduceDownloadDataFromSubscribers(DOWNLOAD_SHEET_ORDER)

  const handleDownload = useCallback(async () => {
    setLoading(true)
    const downloadData = reduceDownloadData()
    if (downloadData) {
      await downloadXlsx(fileName, downloadData, { type, track: () => analytics.track(DASHBOARD_EVENTS.DATA_DOWNLOADED, { format: "xlsx" }) })
    }
    setLoading(false)
  }, [type, fileName, analytics, reduceDownloadData])

  return <div className="excel-download">
    <Tooltip enterDelay={enterDelay} title={title}>
      <span>
        {loading && <CircularProgress size={dimensions.width} />}
        <IconButton
          ref={buttonRef}
          disabled={loading}
          onClick={handleDownload}
          size="large"
        >
          <CloudDownload />
        </IconButton>
      </span>
    </Tooltip>
  </div>
}

DashboardDownload.propTypes = {
  instrumentMetadata: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string.isRequired,
  }).isRequired,
  enterDelay: PropTypes.number,
  isIntraday: PropTypes.bool,
}
